import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/about.css';
import packagingWorker from '../assets/images/package.jpg';

export default function VASActivity() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const services = [
        {
            icon: "fa-tag",
            title: "Stickering and Labelling",
            items: [
                "Barcode and Batch code printing.",
                "Product and Carton Tagging.",
                "Printing Instructions in English and Arabic on adhesive labels.",
                "Ink Jet printing on individual units and cartons."
            ]
        },
        {
            icon: "fa-box-open",
            title: "Insertions",
            items: [
                "Product Casing.",
                "Cataloguing.",
                "Leaflets and Form insertion.",
                "Fill and Seal services.",
                "Compiling assortments and casing."
            ]
        },
        {
            icon: "fa-gift",
            title: "Wrapping and Packaging",
            items: [
                "Shrink-wrapping of different sizes, microns and shapes.",
                "Banding, Bagging and Bundling.",
                "Promotional Packaging solutions.",
                "Cello wrapping for perfumes, creams and lotions."
            ]
        },
        {
            icon: "fa-tools",
            title: "Assembling",
            items: [
                "Component assembling.",
                "Product Sealing.",
                "Professional Packing services."
            ]
        },
        {
            icon: "fa-box",
            title: "Cello Wrapping",
            items: [
                "Perfumes.",
                "Creams.",
                "Lotions."
            ]
        }
    ];

    const vasServices = [
        {
            title: "Wrapping & Packaging",
            items: [
                "Shrink-wrapping of different sizes, microns and shapes.",
                "Cellophane wrapping for perfumes and other luxury HPC products Bagging & Bundling Banding Promo-Packaging."
            ]
        },
        {
            title: "Stickering & Labelling",
            items: [
                "Barcode (STC &Sales units).",
                "Batch code printing.",
                "Printing Instructions in English and Arabic on adhesive labels, products and cartons Tagging Inkjet printing on individual units and cartons."
            ]
        },
        {
            title: "Assembling",
            items: [
                "Assembly of multiple components into single kits / packs.",
                "Sealing finished kits.",
                "Repacking / Refilling for outbound orders."
            ]
        },
        {
            title: "Insertions",
            items: [
                "Casing (Packing in all types of corrugated boxes).",
                "Cataloguing Leaflets Form, Fill and Seal Compiling assortments and casing."
            ]
        }
    ];

    return (
        <>
            {/* Professional Banner Section */}
            <section className="vas-activity-banner">
                <div className="vas-banner-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="vas-banner-content">
                                <div className="vas-breadcrumb mb-3">
                                    <Link to="/" className="breadcrumb-link">Home</Link>
                                    <span className="breadcrumb-separator">›</span>
                                    <span className="breadcrumb-current">VAS Activity</span>
                                </div>
                                <h1 className="vas-banner-title">Promo Packaging & Value-Added Services</h1>
                                <p className="vas-banner-subtitle">
                                    Your product deserves to stand out
                                </p>
                                <div className="vas-banner-divider"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Introduction Section */}
            <section className="vas-intro-section py-5">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="vas-intro-image">
                                <img src={require('../assets/images/valud-added.png')} alt="Packaging Solutions" className="img-fluid rounded shadow-lg" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="vas-intro-content">
                                <h2 className="vas-section-title mb-4">Excellence in Packaging Solutions</h2>
                                <p className="vas-intro-text mb-4">
                                    At <strong>Triburg Freight Services LLC</strong>, we make your products stand out. Our promo packaging solutions
                                    combine creativity with efficiency, helping brands capture attention while ensuring safe and timely delivery.
                                </p>
                                <p className="vas-intro-text">
                                    Triburg offers various packaging, repackaging, and reworking services on diverse types of products,
                                    of varying shapes and sizes. An exclusive warehouse caters especially to our valued co-packing clients,
                                    providing premium services.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Grid Section */}
            <section className="vas-services-section py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 text-center">
                            <h2 className="vas-section-title mb-3">Our Premium Services</h2>
                            <div className="vas-title-divider"></div>
                        </div>
                    </div>

                    <div className="row g-4">
                        {services.map((service, index) => (
                            <div className="col-lg-6 col-md-6" key={index}>
                                <div className="vas-service-card h-100">
                                    <div className="vas-service-icon">
                                        <i className={`fas ${service.icon}`}></i>
                                    </div>
                                    <h3 className="vas-service-title">{service.title}</h3>
                                    <ul className="vas-service-list">
                                        {service.items.map((item, idx) => (
                                            <li key={idx}>
                                                <i className="fas fa-check-circle"></i>
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* NEW: Value Added Services Section with Purple Design */}
            <section className="vas-header-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12 text-center">
                            <h1 className="vas-main-heading">VALUE ADDED SERVICES</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vas-services-grid-section py-5">
                <div className="container">
                    <div className="row g-4">
                        {vasServices.map((service, index) => (
                            <div className="col-lg-6 col-md-6" key={index}>
                                <div className="vas-card h-100">
                                    <h3 className="vas-card-title">{service.title}</h3>
                                    <div className="vas-card-content">
                                        {service.items.map((item, idx) => (
                                            <p key={idx} className="vas-card-text">{item}</p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Image Gallery Section */}
            <section className="vas-gallery-section py-3">
                <div className="container-fluid px-0">
                    <div className="row g-0">
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1601598851547-4302969d0614?w=400" alt="Product 1" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?w=400" alt="Product 2" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1522673607109-978c2b8e8c6e?w=400" alt="Product 3" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=400" alt="Product 4" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=400" alt="Product 5" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                        <div className="col-6 col-md-2 p-1">
                            <div className="vas-gallery-item">
                                <img src="https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=400" alt="Product 6" className="img-fluid vas-gallery-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action Section */}
            <section className="vas-cta-section py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <div className="vas-cta-content">
                                <h2 className="vas-cta-title mb-4">Ready to Enhance Your Products?</h2>
                                <p className="vas-cta-text mb-4">
                                    Let us help you create packaging solutions that make your brand shine.
                                    Contact our team today to discuss your requirements.
                                </p>
                                <Link to="/contact" className="vas-cta-button">
                                    Get in Touch
                                    <i className="fas fa-arrow-right ms-2"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
